import { adminRoutes } from '@/Admin/admin.routes';
const adminModule = {
    routes: adminRoutes
};
export default adminModule;
